export default __webpack_public_path__ + "static/media/36I-114282_-20927_0.60832932.jpg";